import { cmsUrl } from "@/utils/helper";
import axios from "axios";
import { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import Container from "../common/Container";
import BlogCard from "./BlogCard";

const ImportantRead = () => {
  const [category, setCategory] = useState([]);
  const [blog, setBlog] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [latestImage, setLatestImage] = useState([]);
  const [blogCategory, setBlogCategory] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1); // Initialize with 1 page by default
  const [activeCategory, setActiveCategory] = useState(0);
  const fetchDataByCategory = async (categoryId, currPage) => {
    try {
      const response = await axios.get(
        `${cmsUrl}/wp-json/wp/v2/posts?per_page=9${
          categoryId ? `&categories=${categoryId}` : ""
        }&page=${currPage ?? page}`
      );
      setBlog(response.data);

      const totalPagesHeader = response.headers["x-wp-totalpages"]; // Get total pages from response headers
      setTotalPages(Number(totalPagesHeader)); // Convert to number and set total pages

      const imageUrls = await window.Promise.all(
        response.data.map(async (blog) => {
          const imageResponse = await axios.get(
            `${cmsUrl}/wp-json/wp/v2/media/${blog.featured_media}`
          );
          return {
            source_url: imageResponse.data.source_url,
            alt_text: imageResponse.data.alt_text,
          };
        })
      );
      setLatestImage(imageUrls);

      const categoryNames = await window.Promise.all(
        response.data.map(async (blog) => {
          const categoryResponse = await axios.get(
            `${cmsUrl}/wp-json/wp/v2/categories/${blog.categories[0]}`
          );
          return categoryResponse.data.name;
        })
      );
      setBlogCategory(categoryNames);
    } catch (error) {
      console.error("Error fetching blog data:", error);
    }
  };

  useEffect(() => {
    const fetchDataByCategory = async (categoryId, currPage) => {
      try {
        const response = await axios.get(
          `${cmsUrl}/wp-json/wp/v2/posts?per_page=9${
            categoryId ? `&categories=${categoryId}` : ""
          }&page=${currPage ?? page}`
        );
        setBlog(response.data);

        const totalPagesHeader = response.headers["x-wp-totalpages"]; // Get total pages from response headers
        setTotalPages(Number(totalPagesHeader)); // Convert to number and set total pages

        const imageUrls = await window.Promise.all(
          response.data.map(async (blog) => {
            const imageResponse = await axios.get(
              `${cmsUrl}/wp-json/wp/v2/media/${blog.featured_media}`
            );
            return {
              source_url: imageResponse.data.source_url,
              alt_text: imageResponse.data.alt_text,
            };
          })
        );
        setLatestImage(imageUrls);

        const categoryNames = await window.Promise.all(
          response.data.map(async (blog) => {
            const categoryResponse = await axios.get(
              `${cmsUrl}/wp-json/wp/v2/categories/${blog.categories[0]}`
            );
            return categoryResponse.data.name;
          })
        );
        setBlogCategory(categoryNames);
      } catch (error) {
        console.error("Error fetching blog data:", error);
      }
    };

    const fetchData = async () => {
      try {
        const categoryResponse = await axios.get(
          `${cmsUrl}/wp-json/wp/v2/categories`
        );
        setCategory(categoryResponse.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchData();
    fetchDataByCategory(0);
  }, [page]);

  const handleTab = (index) => {
    setActiveTab(index);
    setPage(1);
    fetchDataByCategory(index === 0 ? 0 : category[index - 1].id, 1);
    setActiveCategory(index === 0 ? 0 : category[index - 1].id);
    window.location.hash = "#Important";
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      setPage(page - 1);
      fetchDataByCategory(activeCategory, page - 1);
    }
  };

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1);
      fetchDataByCategory(activeCategory, page + 1);
    }
  };

  return (
    <Container large className="bg-primary-black">
      <h3
        className="text-white font-bold text-2xl lg:text-6xl text-center pb-14 lg:pb-24"
        id="#Important"
      >
        <span>Important to Read</span>
      </h3>
      <div className="flex flex-col md:flex-row gap-x-7">
        <div className="md:w-1/4 lg:bg-[#211819] !px-1 md:!py-5 md:!px-4 lg:!px-6 rounded-lg lg:sticky !top-24 h-fit !mb-20 md:!mb-0">
          <h4 className="font-bold text-base text-white pb-6">CATEGORIES</h4>
          {[{ id: 0, name: "All Categories" }, ...category].map(
            (value, index) => (
              <h4
                className={`text-base inline-block md:block !py-2 !px-3 md:!pb-4 md:!px-0 md:!pt-0 cursor-pointer !border-[0.2px] !border-solid !border-white !border-opacity-20 !rounded-full !mr-2 !mb-2 md:!mr-0 md:!mb-0 md:!border-none ${
                  index === activeTab
                    ? "!text-white !bg-primary-yellow md:!text-primary-yellow md:!bg-transparent !border-none h-full"
                    : "!text-white"
                }`}
                key={value.id}
                onClick={() => {
                  handleTab(index);
                  flushSync(() => {
                    setPage(1);
                  });
                }}
              >
                <span>{value.name}</span>
              </h4>
            )
          )}
        </div>
        <div className="md:w-3/4 ">
          <div className="md:grid md:grid-cols-3 gap-x-5">
            {blog.map((value, index) => (
              <BlogCard
                slug={value.slug}
                key={index}
                src={latestImage[index]?.source_url ?? "/"}
                blogCategory={blogCategory[index]}
                date={value.date}
                title={value.title}
                description={value.content.rendered}
                alt={latestImage[index]?.alt_text}
              />
            ))}
          </div>
          <div className="pt-10 flex justify-between">
            <div>
              <p className="text-white text-base font-medium">
                <span>
                  Page {page} of {totalPages}
                </span>
              </p>
            </div>
            <div className="flex !gap-x-3">
              <button
                className="text-base font-medium !text-white !py-2 !px-3 !border !border-solid !border-white !rounded-lg cursor-pointer disabled:!text-opacity-30 disabled:!border-opacity-30 disabled:cursor-not-allowed"
                disabled={page <= 1}
                onClick={() => {
                  handlePreviousPage();
                }}
              >
                <span>Previous</span>
              </button>
              <button
                className="text-base font-medium !text-white !py-2 !px-3 !border !border-solid !border-white !rounded-lg cursor-pointer disabled:!text-opacity-30 disabled:!border-opacity-30 disabled:cursor-not-allowed"
                disabled={page >= totalPages}
                onClick={() => {
                  handleNextPage();
                }}
              >
                <span>Next</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ImportantRead;
